import { CreditCardStatus, WorkflowPlace } from '@nemuru-eng/js-api-client';

import { CREDIT_CARD_STATUS_DEFINITIONS } from '@/components/modules/CreditCard/List/constants/creditCardStatusConfig';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { CreditCardWorkflow, StatusTagType } from '@/config/types';

interface CreditCardStatusTagProps {
  status: CreditCardStatus;
  workflow?: CreditCardWorkflow;
}

export const CreditCardStatusTag = ({ status, workflow }: CreditCardStatusTagProps) => {
  const isCompleted = workflow?.place.name === WorkflowPlace.COMPLETED;
  const isDenied = workflow?.place.name === WorkflowPlace.DENIED;

  const statusDefinition = CREDIT_CARD_STATUS_DEFINITIONS[status];

  if (!statusDefinition) {
    return null;
  }

  return (
    <>
      {isCompleted ? (
        <StatusTag type={StatusTagType.SUCCESS} labelTextId={'COMPLETED'} />
      ) : isDenied ? (
        <StatusTag type={StatusTagType.ERROR} labelTextId={'DENIED'} />
      ) : (
        <StatusTag
          type={statusDefinition.colorPaletteName as StatusTagType}
          colorType={statusDefinition.colorType as 'main' | 'dark' | 'light'}
          labelTextId={statusDefinition.DESCRIPTION_T_ID}
        />
      )}
    </>
  );
};
